export type Interval = 'day' | 'week' | 'month' | 'year';

export type IntervalConfig = {
  count: number;
  interval: Interval;
};

export type Period = {
  begin: number;
  end: number;
};

interface CouponBase {
  applies_to_display: string;
  type: 'coupon' | 'token';
  amount?: number;
  duration?: string;
  percent_off?: number;
  balance?: string;
}

export interface ProductCoupon extends CouponBase {
  product: 'unify' | 'connect' | 'edge';
  is_ibb: false;
}

export interface IbbCoupon extends CouponBase {
  product: 'edge';
  is_ibb: true;
}

export type CouponError =
  | 'not_found'
  | 'already_used'
  | 'cannot_use'
  | 'no_uses_left'
  | 'misconfigured';

export interface InvalidCoupon {
  error: CouponError;
  conflict?: string[];
}

export type Coupon = ProductCoupon | IbbCoupon;

export function isInvalidCoupon(c: Coupon | InvalidCoupon): c is InvalidCoupon {
  return 'error' in c;
}

export interface Invoice {
  invoice_id: string;
  issued_at: number;
  invoice_number: string;
  status: string;
  available_for_download: boolean;
  amount_paid_usd: number;
  amount_remaining_usd: number;
  total_amount_usd: number;
}

export interface Feature<Id extends string> {
  id: Id;
  name: string;
  description?: string;
}
